<template lang="pug">
	.monitoring-files
		.page-center-content
			.caption-area
				.back(v-if="Layout.pageOptions.backPage")
					button.btn.btn-sm.btn-ghost-secondary(type="button" @click="Layout.setPage.apply(Layout, Layout.pageOptions.backPage)")
						.icon.fa.fa-angle-double-left
				.caption(:class="{'back-exist': Layout.pageOptions.backPage}") Files actions log
			.publishers-table
				DataTable(name="monitoring-files" entity="monitoring_files" :fields="fields" :filters="filters" :buttons="buttons" key-field="id" :sort="['date', 'desc']" :update-on="['Layout Page Showed:files-log']" :update-if="() => Layout.page === 'files-log'" :height-offset="Layout.headerHeight + 45")

</template>

<script>

	import Screen 				from './../../mixins/screen'

	import DataTable			from './../../components/Templates/DataTable'

	export default {
		name: "MonitoringFiles",
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Page Showed:files-log"]
		},
		components: {
			DataTable
		},
		data() {

			// Имена сущностей (user_name, publisher_name) сервер добавляет в строки сам
			this.fields = [
				{
					fieldName: 'id',
					title: 'ID',
					type: 'number',
					display: false,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '70px'
				},
				{
					fieldName: 'date',
					title: 'Date',
					type: 'date',
					class: 'date-only',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '130px'
				},
				{
					fieldName: 'publisher_id',
					title: 'Company',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '150px',
					displayTransform: (value, row) => row["publisher_name"]
				},
				{
					fieldName: 'user_id',
					title: 'User',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '150px',
					displayTransform: (value, row) => row["user_name"]
				},
				{
					fieldName: 'action',
					title: 'Action',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '130px'
				},
				{
					fieldName: 'path',
					title: 'Path',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '250px'
				},
				{
					fieldName: 'title',
					title: 'Title',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '200px'
				},
				{
					fieldName: 'description',
					title: 'Description',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false
				},
				{
					fieldName: 'data',
					title: 'Details',
					type: 'button:confirm',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false
				}
			];

			this.filters = [{
				title: 'Action',
				field: 'action',
				type: 'in',
				value: '',
				options: [
					{title: '', value: ''},
					{title: 'Upload', value: 'upload'},
					{title: 'Download', value: 'download'},
					{title: 'Create folder', value: 'create-folder'},
					{title: 'Rename', value: 'rename'},
					{title: 'Delete', value: 'delete'},
					{title: 'Copy', value: 'copy'},
					{title: 'Move', value: 'move'},
					{title: 'Permissions', value: 'permissions'},
					{title: 'Storage size', value: 'storage-size'}
				],
				display: true
			}];

			this.buttons = [];

			return {
				showed: true
			}

		},
		methods: {
			collectData() {

			}
		}
	}
</script>

<style lang="sass" scoped>

	.monitoring-files
		display: flex !important
		justify-content: center
		color: #fff

		.page-center-content
			width: 100%
			max-width: 1600px
			height: fit-content
			min-height: 100%
			background-color: #3a4149
			border-left: 1px solid rgba(0, 0, 0, 0.3)
			border-right: 1px solid rgba(0, 0, 0, 0.3)

			.caption-area
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				justify-content: flex-start
				background-color: #343b41
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)

				.back
					display: flex
					align-items: center
					justify-content: center
					padding: 0.2rem 1rem

					button
						width: 30px
						height: 30px

				.caption
					padding: 1rem

				.caption.back-exist
					padding: 1rem 0

			.publishers-table
				display: flex
				flex-direction: row
				flex-wrap: wrap
				padding: 1rem 0

</style>
